// extracted by mini-css-extract-plugin
export default {"form-control":"CourseInput_form-control__hxfsh","invalid":"CourseInput_invalid__V4L0w"};